import styles from './index.module.less'
import { ReactNode } from 'react'
import Link from 'next/link'
import useLocale from '@/utils/useLocale'
interface Data {
  title: ReactNode
  video: string
  description: ReactNode
  link?: string
}

interface IProps {
  data: Data
}

const GuideDetail = ({ data }: IProps) => {
  const t = useLocale()
  return (
    <div>
      <div className={styles.video}>
        <video src={data.video} style={{ width: 1000, height: 560 }} controls></video>
      </div>
      <div className={styles.video}>
        <div className={styles.title}>{data?.title}</div>
      </div>
      <div className={styles.video}>
        <div className={styles.description}>
          {data?.description}
          <span>
            {data.link ? (
              <a style={{ marginLeft: 10 }}>
                <Link href={data.link}>{t['go']}</Link>
              </a>
            ) : null}
          </span>
        </div>
      </div>
    </div>
  )
}

export default GuideDetail
